import { render } from "./TransferEditPage.vue?vue&type=template&id=867d2d98"
import script from "./TransferEditPage.vue?vue&type=script&lang=js"
export * from "./TransferEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__